export default __webpack_public_path__ + "static/media/bank.9c4ce6c8.svg";